import React from 'react';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { ProductFavoriteContainer } from 'Components/widgets/product/product-favorite/ProductFavoriteContainer';
type Props = {
  isFilled?: boolean;
  isNextStep?: boolean;
  isSticky: boolean;
  onClick: () => void;
};
export const PriceTicketFavorite = ({ isFilled, isNextStep, isSticky, onClick }: Props) => {
  const iconName = isFilled ? ICONS.STAR_FILLED : ICONS.STAR_HOLLOW;
  const iconColor = isFilled ? COLORS.SUCCESS : COLORS.BLACK;
  return (
    <ProductFavoriteContainer
      displayTooltipTimeoutInMs={4000}
      iconColor={iconColor}
      iconName={iconName}
      isFilled={isFilled}
      isNextStep={isNextStep}
      isSticky={isSticky}
      onClick={onClick}
      tooltipContent={t('common.favoriteOption.favoriteTooltipBE.title')}
      triggerOnHover={!isFilled}
    />
  );
};
